/**
 * Sync membership-in-cart + cart line unit prices on every page load and cart change.
 */
(function () {
  'use strict';

  var config = window.MonthleesMemberPricingConfig || {};
  var membershipIds = config.membershipProductIds || [];
  if (!membershipIds.length && config.membershipProductId) {
    membershipIds = [config.membershipProductId];
  }

  function publishCartState(cart) {
    var hasMembership = false;
    var variantPrices = {};

    (cart.items || []).forEach(function (item) {
      var isMembership = membershipIds.some(function (id) {
        return parseInt(id, 10) === item.product_id;
      });
      if (isMembership) {
        hasMembership = true;
      } else if (item.quantity) {
        variantPrices[item.variant_id] = Math.round(item.final_line_price / item.quantity);
      }
    });

    window.MonthleesCartVariantPrices = hasMembership ? variantPrices : {};

    if (document.body) {
      document.body.setAttribute('data-monthlees-membership-in-cart', hasMembership ? 'true' : 'false');
    }

    document.dispatchEvent(new CustomEvent('monthlees:cart-updated'));
  }

  function refreshCartState() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(publishCartState)
      .catch(function () {});
  }

  function init() {
    refreshCartState();
    document.addEventListener('monthlees:cart-updated', function (event) {
      if (event.detail && event.detail.cart) {
        publishCartState(event.detail.cart);
      }
    });
  }

  window.MonthleesCartCatalogState = {
    refresh: refreshCartState,
    publish: publishCartState,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
